import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import BackgroundImage from '../background-image/BackgroundImage';

import CommonLoader from '../../../../components/common-loader/CommonLoader';
import FailedMedia from '../../../../ai-studio/components/failed-media/FailedMedia';

import scss from './Activ8Image.module.scss';

function Activ8Image({
  image,
  src,
  backgroundSrc,
  onPreview,
  onError,
  backgroundImageStyle,
  imageClassName,
  isExpired,
  lazy = false,
}) {
  const [fallbackBackground, setFallbackBackground] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(false);

  const isLoading = !!src && !isLoaded && !error;
  const backgroundImage = backgroundSrc || fallbackBackground;

  useEffect(() => {
    setIsLoaded(false);
    setFallbackBackground(null);
    setError(false);
  }, [src, backgroundSrc]);

  useEffect(() => {
    if (!src) {
      setError(true);
      onError?.();
    }
  }, [src, onError]);

  const handleLoad = () => {
    setIsLoaded(true);
    if (!backgroundSrc) {
      setFallbackBackground(src);
    }
  };

  const handleLoadingError = () => {
    setError(true);
    onError?.();
  };

  const handleImageClick = () => {
    if (isExpired || !onPreview) return;
    onPreview(image);
  };

  if (!src) {
    return <FailedMedia />;
  }

  return (
    <>
      {!error ? (
        <>
          <BackgroundImage src={backgroundImage} alt='background blurred image' style={{ ...backgroundImageStyle }} />
          <img
            src={src}
            alt=''
            className={clsx(scss.slideImage, imageClassName, isExpired && scss.expired)}
            onLoad={handleLoad}
            onError={handleLoadingError}
            draggable={!isExpired}
            onDragStart={isExpired ? (e) => e.preventDefault() : undefined}
            onContextMenu={isExpired ? (e) => e.preventDefault() : undefined}
            {...(!isExpired && onPreview ? { onClick: handleImageClick, onKeyDown: handleImageClick } : {})}
            role='presentation'
            {...(lazy ? { loading: 'lazy', decoding: 'async' } : {})}
          />
        </>
      ) : null}
      <CommonLoader isLoading={isLoading} />
      {error ? <FailedMedia /> : null}
    </>
  );
}

export default Activ8Image;
